export default __webpack_public_path__ + "static/spitz-phones-1ef1fa32e848a94650d74ac83ff46ac8.jpg";